import { GenericMenu } from "../types";
import config from "../config";
import { useScadaPlusQuery } from "./useScadaPlusQuery";
import { getEnvConfig } from "env";

export const useGetMenu = () => {
  return useScadaPlusQuery<GenericMenu>(
    `menu`,
    `${getEnvConfig("API_URL")}/api/${config.api.menu}`,
  );
};
